module.exports = __webpack_public_path__ + "static/01-2f915d5708ae32b97f776ab8e270039d.jpg";